// extracted by mini-css-extract-plugin
export default {"buttonInserts":"insertNames_buttonInserts__sDslI"};